import React, { useEffect, useRef } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import {
  Wrap,
  Inner,
  Heading,
  Grid,
  Card,
  Media,
  Content,
  Badge,
  Eyebrow,
  Title,
  Desc,
  CTA,
  Underline,
} from "./FeatureTriptychStyles";

export default function FeatureTriptych({
  accent = "#d4af37",
  heading = "Rafinament în trei imagini",
  items = DEFAULTS,
}) {
  const refs = useRef([]);

  useEffect(() => {
    const els = refs.current.filter(Boolean);
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [items]);

  return (
    <Wrap $accent={accent} aria-label="galerie elegantă cu trei imagini">
      <Inner>
        <Heading>
          <h2>{heading}</h2>
          <div className="rule" aria-hidden="true">
            <span className="line" />
            <span className="dot" />
            <span className="line" />
          </div>
        </Heading>

        <Grid role="list">
          {items.slice(0, 3).map((it, i) => (
            <Card
              key={it.id ?? i}
              role="listitem"
              ref={(el) => (refs.current[i] = el)}
              tabIndex={-1}
            >
              <Media>
                <img src={it.image} alt={it.title} loading="lazy" />
              </Media>

              <Badge>
                {String(i + 1).padStart(2, "0")}
                <span
                  style={{
                    width: 36,
                    height: 1,
                    background: "rgba(255,255,255,.45)",
                  }}
                />
              </Badge>

              <Content>
                {it.eyebrow && <Eyebrow>{it.eyebrow}</Eyebrow>}
                <Title>{it.title}</Title>
                <Underline aria-hidden="true" />
                {it.desc && <Desc>{it.desc}</Desc>}

                {it.href && (
                  <CTA
                    href={it.href}
                    aria-label={`${it.title} — ${it.ctaLabel || "Detalii"}`}
                  >
                    {it.ctaLabel || "Detalii"}
                    <FiArrowUpRight />
                  </CTA>
                )}
              </Content>
            </Card>
          ))}
        </Grid>
      </Inner>
    </Wrap>
  );
}
